import { inject, Injectable } from "@angular/core";
import { GraphService } from "@app/kernel/graphql/services/graph.service";
import { IExpirationSettings } from "@app/shared/expiration-settings/interfaces/expiration-settings.interface";
import { EXPIRAITON_SETTINGS_QUERY } from "@app/shared/expiration-settings/query/expiration-settings.query";
import { map } from "rxjs";

@Injectable({ providedIn: "root" })
export class QuotaitonExpirationSettingsApiService {
  private graphService = inject(GraphService);

  getQuotationExpirationSettings() {
    return this.graphService
      .constructWatchQuery<{
        getQuotationExpirationSettings: IExpirationSettings[];
      }>([EXPIRAITON_SETTINGS_QUERY], "getQuotationExpirationSettings")
      .pipe(
        map(res => {
          if (res.errors?.length) throw res.errors.length;
          return res.data.getQuotationExpirationSettings;
        })
      );
  }
}
